export const PURCHASER_KEY_ALREADY_EXISTS_MESSAGE =
  "This Purchaser Key already exists.";

export const PURCHASER_SAVE_NETWORK_ERROR_MESSAGE =
  "Failed to save changes. Please try again later.";

export const PURCHASER_KEY_MAX_LENGTH = 50;
export const PURCHASER_NAME_MAX_LENGTH = 255;
export const SEARCH_KEYWORDS_MAX_LENGTH = 255;
export const DISCOUNT_PERCENT_MAX = 9.99;
export const TERM_DAYS_MAX = 999;

export const SEARCH_KEYWORDS_PIPE_MESSAGE =
  'Separate keywords with " | " (space, pipe, space).';

/** One or more keywords with no spaces, joined only by " | ". Empty is valid. */
export const SEARCH_KEYWORDS_FORMAT = /^[^\s|]+(?: \| [^\s|]+)*$/;

export function getSearchKeywordsError(raw: unknown): string | null {
  const value = typeof raw === "string" ? raw.trim() : "";
  if (!value || SEARCH_KEYWORDS_FORMAT.test(value)) {
    return null;
  }
  return SEARCH_KEYWORDS_PIPE_MESSAGE;
}

export function validateSearchKeywords(raw: unknown): Promise<void> {
  const error = getSearchKeywordsError(raw);
  if (error) {
    return Promise.reject(new Error(error));
  }
  return Promise.resolve();
}

function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === "string") {
    return error;
  }
  return "";
}

export function isPurchaserKeyDuplicateError(error: unknown): boolean {
  const normalized = getErrorMessage(error).toLowerCase();
  return (
    normalized.includes("purchaser key") ||
    normalized.includes("duplicate") ||
    normalized.includes("already exists")
  );
}
